import React from 'react';
import PurchaseOrderList from '../../../../pages/purchases/list/PurchaseOrderList';

const PurchaseOrdersInSupplier = ({ id }: { id?: string }) => {
  return id ? <PurchaseOrderList independent={false} extraFilter={`supplierId:${id}`} /> : null;
};

export default PurchaseOrdersInSupplier;
